import React from 'react';
import { LayoutCardWrapper, PaginationWrapper, Wrapper } from './pagination-layout.styles';
import { PaginationLayoutProps } from './types';
import { Pagination } from '../pagination/pagination';
import { usePagination } from '@shared/lib/hooks/use-pagination/use-pagination';

export const PaginationLayout: React.FC<PaginationLayoutProps> = ({
    isLoading,
    parameters,
    listLength,
    customCountsOnPage,
    children,
    setParameters,
}) => {
    const { maxPage, currentPage, paginationParameters, isHiddenPagination } = usePagination({
        take: parameters.take || null,
        skip: parameters.skip || null,
        total: listLength,
    });

    const handleChangeCurrentPage = async (page: number) => {
        const newParameters = { ...parameters, ...paginationParameters({ page }) };
        setParameters(newParameters);
    };

    const handleChangeCountOnPage = async (elementsOnPage: number) => {
        const newParameters = { ...parameters, ...paginationParameters({ elementsOnPage }) };
        setParameters(newParameters);
    };

    return (
        <Wrapper>
            <LayoutCardWrapper>{children}</LayoutCardWrapper>
            <PaginationWrapper isHidden={isHiddenPagination}>
                <Pagination
                    disabled={isLoading}
                    customCountsOnPage={customCountsOnPage}
                    count={maxPage}
                    currentPage={currentPage}
                    countOnPage={parameters.take}
                    onChangePage={handleChangeCurrentPage}
                    onChangeCountOnPage={handleChangeCountOnPage}
                />
            </PaginationWrapper>
        </Wrapper>
    );
};
